<div mat-dialog-title>
  <div class="flex items-center justify-between h-48">
    <h6>Change Quoting System</h6>
    <button matIconButton aria-label="Close" mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
<mat-divider class="mx-20!" />
<div mat-dialog-content>
  <form [formGroup]="moveQSForm">
    <div class="grid grid-cols-[1fr_1fr_188px] gap-x-20">
      <mat-form-field>
        <mat-label>From</mat-label>
        <mat-select formControlName="from">
          @for (qs of quotingSystemsList(); track qs) {
            <mat-option [value]="qs.clientId">{{ qs.companyName }}</mat-option>
          }
        </mat-select>
        @if (from.hasError('required')) {
          <mat-error> From is <strong>required</strong> </mat-error>
        }
      </mat-form-field>
      <mat-form-field>
        <mat-label>To</mat-label>
        <mat-select formControlName="to">
          @for (qs of quotingSystemsList(); track qs) {
            <mat-option [value]="qs.clientId">{{ qs.companyName }}</mat-option>
          }
        </mat-select>
        @if (to.hasError('required')) {
          <mat-error> To is <strong>required</strong> </mat-error>
        }
      </mat-form-field>
      <mat-form-field class="primary-icon">
        <mat-label>Initial Date</mat-label>
        <input
          (keypress)="dateInputHelper.restrictDateInput($event)"
          [matDatepicker]="initialDatepicker"
          formControlName="initialDate"
          matInput />
        <mat-datepicker-toggle [for]="initialDatepicker" matSuffix></mat-datepicker-toggle>
        <mat-datepicker #initialDatepicker></mat-datepicker>
        <mat-hint>Date format DD/MM/YYYY</mat-hint>
        @if (initialDate.hasError('required') && !initialDate.hasError('matDatepickerParse')) {
          <mat-error> Initial Date is <strong>required</strong> </mat-error>
        }
        @if (initialDate.hasError('matDatepickerParse')) {
          <mat-error> The date format is <strong>DD/MM/YYYY</strong> </mat-error>
        }
      </mat-form-field>
    </div>
    @if (from.valid && to.valid && initialDate.valid) {
      <div class="flex justify-center items-center mb-15 gap-x-5 text-neut-50">
        <mat-icon>info_outline</mat-icon>
        @if (!duplicateFromTo()) {
          <span class="body-1">
            {{ movingQSMessage() }}
          </span>
        } @else {
          <span class="body-1"> You must select two different quoting systems. </span>
        }
      </div>
    }
  </form>
</div>
<mat-divider class="mx-20!" />
<mat-dialog-actions>
  <button matButton="elevated" class="charcoal-button" mat-dialog-close>CANCEL</button>
  <button
    matButton="elevated"
    class="red-button"
    [disabled]="loading() || moveQSForm.invalid || moveQSForm.pristine || duplicateFromTo()"
    (click)="confirmMoveQuotingSystem()">
    SAVE
  </button>
</mat-dialog-actions>
